import { render, staticRenderFns } from "./HuliContact.vue?vue&type=template&id=75b968c6&scoped=true"
import script from "./HuliContact.vue?vue&type=script&lang=js"
export * from "./HuliContact.vue?vue&type=script&lang=js"
import style0 from "./HuliContact.vue?vue&type=style&index=0&id=75b968c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b968c6",
  null
  
)

export default component.exports